import { getReletedVideo } from "./relatedVideoApi";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  reletedVideos: [],
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchReletedVideo = createAsyncThunk(
  "reletedVideo/fetchReletedVideo",
  async ({ id, tags }) => {
    // console.log(id, tags);
    const reletedVideo = await getReletedVideo({ tags, id });
    return reletedVideo;
  }
);

const reletedVideoSlice = createSlice({
  name: "reletedVideo",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchReletedVideo.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchReletedVideo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.reletedVideos = action.payload;
      })
      .addCase(fetchReletedVideo.rejected, (state, action) => {
        state.isLoading = false;
        state.reletedVideos = [];
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default reletedVideoSlice.reducer;
